import type { CancellationAndDelayMetrics } from "@repo/ui/types/flights";

export const sortOptions = [
  "Más barato", // Cheapest
  "Salida más temprano", // Earliest departure
  "Salida más tarde", // Latest departure
] as const;

export enum FlightTypeEnum {
  DIRECT = "direct",
  CONNECTING = "connecting",
  STOPOVER = "stopover",
}

export enum TripTypeEnum {
  ONE_WAY = "one-way",
  ROUND_TRIP = "round-trip",
}

export type TripResponsev2 = {
  trips: Tripsv2;
}[];
export type Tripsv2 = Tripv2[];
export type Journeysv2 = Journeyv2[];
export type Faresv2 = Farev2[];
export type FareDetailsv2 = FareDetailv2[];
export type Bundlesv2 = Bundlev2[];
export type Segmentsv2 = Segmentv2[];
export type Legsv2 = Legv2[];
export type TripType = "one-way" | "round-trip";
export type FlightType = "direct" | "connecting" | "stopover";
export type FlightStopType = "layover" | "stopover";
export type FlightSegmentType = "departure" | "arrival" | "layover" | "stopover";
export interface FlightDetails {
  id: string;
  departureTime: string;
  departureLocation: string;
  departureLocationCode: string;
  arrivalTime: string;
  arrivalLocation: string;
  arrivalLocationCode: string;
  flightCode: string;
  flightType: FlightType;
  flightDuration: string;
  airline: string;
  discountClubPrice: string;
  standardPrice: string;
  lowestPrice?: string;
  taxedDiscountClubPrice: string;
  taxedStandardPrice: string;
  taxedLowestPrice?: string;
  promoType: string;
}

export interface FlightAvailabilityResponse {
  data: FlightAvailabilityData;
  error: FlightAvailabilityError | null;
  message: string;
  success: boolean;
}

interface FlightAvailabilityError {
  code: string;
  message: string;
}

export interface FlightAvailabilityData {
  currencyCode: string;
  faresAvailable: FaresAvailablev2;
  includeTaxesAndFees: boolean;
  results: TripResults[];
}

export interface FaresAvailablev2 {
  fareAvailabilityKey: string[];
  fares: Faresv2;
}

export interface Farev2 {
  fareAvailabilityKey?: string;
  memberFare: number;
  memberFareInclusiveTax: number;
  dcFare: number;
  dcFareInclusiveTax: number;
}

export interface FareDifference extends Farev2 {
  promotionDiscountAmount?: number;
  fareDifference?: number;
  fareDifferenceInclusiveTax?: number;
  dcFareDifference?: number;
  dcFareDifferenceInclusiveTax?: number;
}

export interface TripResults {
  trips: Tripv2[];
}

export interface Tripv2 {
  date: string;
  journeysAvailableByMarket: JourneysAvailableByMarket;
}

export interface JourneysAvailableByMarket {
  [key: string]: Journeysv2;
}

export interface Journeyv2 {
  designator: JourneyDesignatorv2;
  fares: JourneyFaresv2;
  bundleAvailability: Bundlesv2;
  flightType: number | FlightType;
  journeyKey: string;
  notForGeneralUser: boolean;
  segments: Segmentsv2;
  stops: number;
}

export interface JourneyDesignatorv2 {
  arrival: string;
  departure: string;
  destination: string;
  destinationName?: string;
  origin: string;
  originName?: string;
  flightDuration: string;
}

export type JourneyFaresv2 = JourneyFarev2[];
export interface JourneyFarev2 {
  details: FareDetailsv2;
  fareAvailabilityKey: string;
}
export interface FareDetailv2 {
  availableCount: number;
  reference: string;
  status: number;
  bundleAvaliabilty: string[];
}

export interface Bundlev2 {
  bundleReference?: string;
  bundlePriceTotal: number;
  bundleTaxTotal: number;
  bundleCode: string;
  bundleSSRs: string[];
}

export interface Segmentv2 {
  identifier: SegmentIdentifierv2;
  isChangeOfGauge: boolean;
  legs: Legv2[];
  segmentKey: string;
  segmentType: number;
  cancellationAndDelayMetrics?: CancellationAndDelayMetrics;
}

export interface SegmentIdentifierv2 {
  carrierCode: string;
  identifier: string;
  opSuffix: string | null;
}

export interface Legv2 {
  flightReference: string;
  legInfo: LegInfov2;
  designator: LegDesignatorv2;
}

export interface LegDesignatorv2 {
  destination: string;
  origin: string;
  arrival: string;
  departure: string;
  destinationName: string;
  originName: string;
}

export interface LegInfov2 {
  arrivalTime: string;
  arrivalTimeUtc: string;
  connectionTime: string;
  departureTime: string;
  departureTimeUtc: string;
  equipmentType: string;
  equipmentTypeSuffix: string;
  flightDuration: string;
  operatedByText: string;
}

export type SortOption = (typeof sortOptions)[number];

export interface MonthData {
  [key: string]: FlightPrice[];
}

export interface FlightPrice {
  date: number;
  day: string;
  price: number | string;
  isSmartPrice?: boolean;
  smartPrice?: number | string;
  isLowestPrice?: boolean;
  lowestPrice?: number | string;
}

export interface BookingState {
  origin: string;
  destination: string;
  beginDate: string;
  endDate: string;
}
